import { FC } from "react";

import { Stack } from "@mui/material";
import { FormType } from "@simplyk/common";

import { CampaignDate } from "../../../../blocks/campaign-details/CampaignDate/CampaignDate";
import { CampaignLocation } from "../../../../blocks/campaign-details/CampaignLocation/CampaignLocation";
import { CampaignTitle } from "../../../../blocks/campaign-details/CampaignTitle/CampaignTitle";
import { SalesOpeningChip } from "../../../../blocks/campaign-details/SalesOpeningChip/SalesOpeningChip";
import { useSalesOpenSchedule } from "../../../../blocks/campaign-details/SalesOpeningChip/useSalesOpenSchedule";
import { TicketingClosedChip } from "../../../../blocks/campaign-details/TicketingClosedChip/TicketingClosedChip";
import { TicketingV2OccurrenceSelector } from "../../../../blocks/selection/ticketing-selection/OccurrenceSelector/TicketingV2OccurrenceSelector";
import { useFormV2Context } from "../../../../contexts/FormV2Context";

import { TicketingV2CoreInfoLayout } from "./TicketingV2CoreInfoLayout";

export type TicketingV2CoreInfoProps = Record<string, never>;

export const TicketingV2CoreInfo: FC<TicketingV2CoreInfoProps> = () => {
  const { formObject, isEmbed, hasLocation, hasDate, numberOfOccurrences } = useFormV2Context(FormType.Ticketing);
  const { isTicketingClosed: ticketingIsClosed } = useFormV2Context(FormType.Ticketing);

  const { isSalesScheduled } = useSalesOpenSchedule();

  return (
    <TicketingV2CoreInfoLayout
      isEmbed={isEmbed}
      slots={{
        status: (formObject.isArchived || ticketingIsClosed) && <TicketingClosedChip />,
        formTitle: isSalesScheduled ? (
          <Stack gap={2}>
            <SalesOpeningChip />
            <CampaignTitle />
          </Stack>
        ) : (
          <CampaignTitle />
        ),
        location: hasLocation ? <CampaignLocation /> : undefined,
        date: hasDate && numberOfOccurrences === 1 ? <CampaignDate /> : undefined,
        occurrenceSelector: numberOfOccurrences > 1 ? <TicketingV2OccurrenceSelector /> : undefined,
      }}
    />
  );
};
